module.exports = __webpack_public_path__ + "assets/img/bg-login.eee73c4c.jpg";